/**
 * WHICH decision context the Intake category gate's picker declares
 * (2026-09-16, the Intake deadlock).
 *
 * The gate opens for two reasons, and the picker must say WHICH one it is
 * answering - the server cross-checks the declaration against the stored
 * document and refuses a mismatch with 400, before writing anything:
 *
 *   forced_low_signal         the zero-floor gate: category_confidence is the
 *                             string 'none' (a pick with no signal behind it,
 *                             or a header no-fit, which sets the same label).
 *   retired_category_replaced the stored header no longer resolves to an
 *                             ACTIVE category (categoryActiveResolvable ===
 *                             false) and the low-signal label is NOT set.
 *
 * Until 2026-09-16 the call site hard-coded forced_low_signal. For a retired
 * incumbent - a confident pick, confidence absent - the server refused every
 * selection, and the passive "change" link (voluntary_change) renders only
 * when the gate is CLOSED: the buyer was trapped (PROC-000353).
 *
 * THE LOW-SIGNAL LABEL WINS where it is set, because that is the state the
 * server's cross-check reads first; a document carrying both a 'none' label
 * and a retired header is answered as low-signal. `=== false`, not falsy:
 * null means the master could not be read, and the gate does not open on it.
 *
 * A JS<->Python TOKEN PAIR, registered in CLAUDE.md: the two strings below
 * must match ProcurementRequestCreate.decision_context's Literal in
 * backend/routes/procurement.py. backend/tests/test_intake_retired_category_
 * reselection.py source-scans this file for both.
 *
 * Returns the context, or null when neither reason holds (the gate is not
 * open, so there is nothing for the picker to answer).
 */
export const FORCED_LOW_SIGNAL = 'forced_low_signal';
export const RETIRED_CATEGORY_REPLACED = 'retired_category_replaced';

export const categoryGateDecisionContext = ({ confidence, categoryActiveResolvable }) => {
  if (confidence === 'none') return FORCED_LOW_SIGNAL;
  if (categoryActiveResolvable === false) return RETIRED_CATEGORY_REPLACED;
  return null;
};
